import React, { useState, useEffect } from "react";
import { Avatar, Box, Tooltip } from "fds";
import "./index.scss";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import { Route, Routes, useNavigate } from "react-router-dom";
import ClientWorkgorup from "./Page/ClientWorkgroup";
import ClientBookmark from "./Page/ClientBookmark";
import utilsCommon from "../../shared/utils/common";
import ClientSearch from "./Page/ClientSearch";
import dayjs from "dayjs";

const ClientEco = () => {
  const navigate = useNavigate();
  const { workgroupState, getWorkgroupSideList } = useWorkgroupStore();
  const [workgroupList, changeWorkgroupList] = useState<Workgroup[]>();
  const [focusedWorkgroupId, changeFocusedWorkgroupId] = useState<
    string | undefined
  >(undefined);
  useEffect(() => {
    getWorkgroupSideList({
      isDetail: "Y",
      managerId: "",
      orderBy: "workgroupName",
      orderByType: "ASC",
      pageRange: 1,
      posPage: 1,
      rowRange: 0,
      searchDate: { start: 0, end: 0 },
      status: 1,
      workgroupName: "",
    }).then((resp: any) => {
      if (
        resp.payload?.workgroupList.filter(
          (item: Workgroup) => item.isValidate === 1
        )?.length === 0
      ) {
        navigate(`${process.env.PUBLIC_URL}/client/none`);
      }
    });
  }, []);
  useEffect(() => {
    if (focusedWorkgroupId) {
      navigate(
        `${process.env.PUBLIC_URL}/client/workgroup/${focusedWorkgroupId}`
      );
      if (utilsCommon.isClientLogin("MAC")) {
        (window as any)?.webkit?.messageHandlers.unMarkFavorite.postMessage("");
      } else if (utilsCommon.isClientLogin("WINDOWS")) {
        window?.chrome?.webview?.hostObjects.client.unMarkFavorite();
      }
    }
  }, [focusedWorkgroupId]);
  useEffect(() => {
    let sorted_workgroup = workgroupState.workgroupSidemenuList
      .filter(
        (item: Workgroup) =>
          item.endDate === -1 || item.endDate > dayjs().valueOf()
      )
      .slice()
      .sort((a: Workgroup, b: Workgroup) => {
        if (a.favorite === "Y" && b.favorite !== "Y") return -1;
        if (a.favorite !== "Y" && b.favorite === "Y") return 1;
        return 0; // 원래 순서 유지
      });

    changeWorkgroupList(sorted_workgroup);
    if (window.location.href.includes("/workgroup") && !focusedWorkgroupId) {
      changeFocusedWorkgroupId(sorted_workgroup[0]?.workgroupId);
    }
  }, [workgroupState.workgroupSidemenuList]);
  return (
    <Box classes="clientEco">
      <Box classes="clientEco-sidemenu overflow-scroll">
        {workgroupList?.map((item: Workgroup) => (
          <Tooltip message={item.workgroupName} place="right">
            <Box
              classes="clientEco-workgroup"
              onClick={() => changeFocusedWorkgroupId(item?.workgroupId)}
            >
              {focusedWorkgroupId === item.workgroupId && (
                <Box classes="clicked" />
              )}
              <Avatar
                uniqueCode={item.workgroupId}
                name={item.workgroupName}
                shape="workgroup"
              />
            </Box>
          </Tooltip>
        ))}
      </Box>
      <Routes>
        <Route path={`/workgroup/:workgroupId`} element={<ClientWorkgorup />} />
        <Route path={`/storage`} element={<ClientBookmark />} />
        <Route path={`/search`} element={<ClientSearch />} />
      </Routes>
    </Box>
  );
};

export default ClientEco;
